import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../../api";
import type { UpdateReviewRequest } from "../types";
import { invalidateEvalStewardQueries } from "../utils/invalidateEvalStewardQueries";

export interface UpdateAnnotationReviewVariables {
  workspaceId: string;
  annotationId: string;
  threadId: string;
  assistantMessageIndex: number;
  body: UpdateReviewRequest;
}

export function useUpdateAnnotationReview() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      workspaceId,
      annotationId,
      body,
    }: UpdateAnnotationReviewVariables) =>
      api.updateEvalAnnotationReview(workspaceId, annotationId, body),
    onSuccess: (_annotation, variables) => {
      invalidateEvalStewardQueries(
        queryClient,
        {
          workspaceId: variables.workspaceId,
          threadId: variables.threadId,
          assistantMessageIndex: variables.assistantMessageIndex,
        },
        variables.annotationId,
      );
    },
  });
}
